/* eslint-disable */
import { URL_API_SERVICE } from '../../config';
import axios from 'utils/axios';

class notificacionServices {
    getInbox = (id_company, id_users) =>
        new Promise((resolve, reject) => {
            axios
                .post(
                    URL_API_SERVICE + 'notificacion',
                    { operacion: 'getInbox', id_company, id_users, data: { soloAbiertas: true } },
                    this.getToken()
                )
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    this.check_token(error);
                    reject(error);
                });
        });

    countNoLeidas = (id_company, id_users) =>
        new Promise((resolve, reject) => {
            axios
                .post(URL_API_SERVICE + 'notificacion', { operacion: 'countNoLeidas', id_company, id_users }, this.getToken())
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    this.check_token(error);
                    reject(error);
                });
        });

    marcarLeida = (id_notificacion, id_company, id_users) =>
        new Promise((resolve, reject) => {
            axios
                .post(
                    URL_API_SERVICE + 'notificacion',
                    { operacion: 'marcarLeida', id: id_notificacion, id_company, id_users },
                    this.getToken()
                )
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    this.check_token(error);
                    reject(error);
                });
        });

    marcarTodasLeidas = (id_company, id_users) =>
        new Promise((resolve, reject) => {
            axios
                .post(URL_API_SERVICE + 'notificacion', { operacion: 'marcarTodasLeidas', id_company, id_users }, this.getToken())
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    this.check_token(error);
                    reject(error);
                });
        });

    getAllByIdCompanyPaginate = (id_company, filters, pagination) =>
        new Promise((resolve, reject) => {
            axios
                .post(
                    URL_API_SERVICE + 'notificacion',
                    {
                        operacion: 'getAllByIdCompanyPaginate',
                        id_company,
                        data: { filters: filters || {} },
                        pagination
                    },
                    this.getToken()
                )
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    this.check_token(error);
                    reject(error);
                });
        });

    getLectores = (id_notificacion, id_company) =>
        new Promise((resolve, reject) => {
            axios
                .post(
                    URL_API_SERVICE + 'notificacion',
                    { operacion: 'getLectores', id: id_notificacion, id_company },
                    this.getToken()
                )
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    this.check_token(error);
                    reject(error);
                });
        });

    ejecutarCronSri = (id_company) =>
        new Promise((resolve, reject) => {
            axios
                .post(
                    URL_API_SERVICE + 'notificacion',
                    { operacion: 'ejecutarCronSri', id_company, data: { id_company, minutos: 5 } },
                    this.getToken()
                )
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    this.check_token(error);
                    reject(error);
                });
        });

    getToken() {
        const token_v = localStorage.getItem('serviceToken');
        return {
            headers: {
                Authorization: 'Bearer ' + token_v
            }
        };
    }

    check_token(error) {
        if (error && error.error === 'jwt expired') {
            localStorage.removeItem('serviceToken');
            delete axios.defaults.headers.common.Authorization;
            window.location.reload();
        }
    }
}

const instance = new notificacionServices();
export default instance;
